import { Range } from 'slate';
import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

import { IComboboxItem } from '../types';

export interface ComboBoxState {
  key: string;
  setKey: (value: string) => void;

  maxSuggestions: number;
  setMaxSuggestions: (value: number) => void;

  search: string;
  setSearch: (value: string) => void;

  // Fetched tags
  items: IComboboxItem[];
  setItems: (value: IComboboxItem[]) => void;

  // Range from the tag trigger to the cursor
  targetRange: Range | null;
  setTargetRange: (value: Range | null) => void;

  // Highlighted index
  itemIndex: number;
  setItemIndex: (value: number) => void;

  closeMenu: () => void;
}
const slateImmer = (config) => config;
export const useComboBoxStore = create<ComboBoxState, [['zustand/devtools', ComboBoxState]]>(
  devtools(
    slateImmer((set, get) => ({
      key: '',
      setKey: (key) => set({ key }),

      maxSuggestions: 100,
      setMaxSuggestions: (num) => set({ maxSuggestions: num }),

      search: '',
      setSearch: (search) => set({ search: search }),

      items: [],
      setItems: (items) => set({ items: items }),

      targetRange: null,
      setTargetRange: (range) => set({ targetRange: range }),

      itemIndex: 0,
      setItemIndex: (index) => set({ itemIndex: index }),

      closeMenu: () => {
        set((state) => {
          state.targetRange = null;
          state.items = [];
          state.search = '';
          state.itemIndex = 0;
        });
      },
    }))
  )
);
